const ts = () => new Date().toISOString();

const logger = {
  info: (msg, meta) => console.log(`[INFO ${ts()}] ${msg}`, meta || ''),
  warn: (msg, meta) => console.warn(`[WARN ${ts()}] ${msg}`, meta || ''),
  error: (msg, meta) => console.error(`[ERROR ${ts()}] ${msg}`, meta || ''),
  debug: (msg, meta) => {
    if (process.env.NODE_ENV !== 'production') console.debug(`[DEBUG ${ts()}] ${msg}`, meta || '');
  },
};

export default logger;